import * as React from "react";
const SvgFiRrDownLeftAndUpRightToCenter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-down-left-and-up-right-to-center_svg__a)">
      <path
        fill="#062147"
        d="m23.707 1.707-5.405 5.405 2.463 2.463c.506.506.14 1.378-.58 1.383L13.803 11a.795.795 0 0 1-.803-.803l.042-6.382c.005-.72.877-1.086 1.383-.58l2.463 2.463L22.293.293a.999.999 0 1 1 1.414 1.414M10.197 13l-6.382.042c-.72.005-1.086.877-.58 1.383l2.463 2.463-5.405 5.405a.999.999 0 1 0 1.414 1.414l5.405-5.405 2.463 2.463c.506.506 1.378.14 1.383-.58L11 13.803a.795.795 0 0 0-.803-.803"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-down-left-and-up-right-to-center_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDownLeftAndUpRightToCenter;
